export class Utils {
  /**
   * Generic sort by any property with ASC/DESC and locale-aware string compare.
   * Returns a new shallow-copied, sorted array.
   */
  static sortByProperty<T extends object>(
    items: T[],
    property: keyof T,
    order: 'ASC' | 'DESC' = 'ASC',
  ): T[] {
    if (!Array.isArray(items) || items.length === 0) return [];
    const dir = order === 'DESC' ? -1 : 1;
    return [...items].sort((a, b) => {
      const aVal = a[property];
      const bVal = b[property];
      if (aVal === bVal) return 0;
      if (aVal == null) return 1 * dir;
      if (bVal == null) return -1 * dir;
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return aVal.localeCompare(bVal) * dir;
      }
      return (aVal < bVal ? -1 : 1) * dir;
    });
  }
}
